<template>
    <select v-model="claimType">
        <option :value="null">All</option>
        <option value="all_fatal_types">All Fatal Types</option>
        <option value="fatal_accident_estate">Fatal Accident Estate</option>
        <option value="fatal_accident_dependency">Fatal Accident Dependency</option>
        <option value="lost_years">Lost Years</option>
        <option value="personal_injury" v-if="diseaseOrAccident !== 'disease'">Personal Injury</option>
    </select>
</template>

<script>
    export default {
        name: 'claim-type',
        computed: {
            claimType: {
                get() {
                    return this.$store.getters['dashboards/claimType'];
                },
                set(value) {
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'claimType', value})
                },
            },
            diseaseOrAccident: {
                get() {
                    return this.$store.getters['dashboards/diseaseOrAccident'];
                },
            },
        },
    }
</script>



// WEBPACK FOOTER //
// ClaimType.vue?25f04ec6